import { render, staticRenderFns } from "./IndicadorProyectosArea.vue?vue&type=template&id=b4a1e4cc&"
import script from "./IndicadorProyectosArea.vue?vue&type=script&lang=js&"
export * from "./IndicadorProyectosArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports